function wrapperReducer(state = [], action) {
    const { type, payload } = action;
    let showProgress, progress;

    switch(type) {
        case "LOADER":
        case "ERROR":
            return Object.assign({}, state, { ...payload });
        
        case "CLEAR_ERROR":
            return Object.assign({}, state, { error: null });

        case "CLEAR_LOADERS":
            return Object.assign({}, state, { loader: false, progress: 0, showProgress: false });

        case "START_PROGRESS":
            showProgress = true;
            progress = 0;
            return Object.assign({}, state, { ...payload, showProgress, progress });

        case "UPDATE_PROGRESS":
            return Object.assign({}, state, { ...payload });

        case "END_PROGRESS":
            showProgress = false;
            progress = 100;
            return Object.assign({}, state, { ...payload, showProgress, progress });

        case "UNSET_STATE":
            return Object.assign({}, {});

        case "USER_LOGOUT":
            return Object.assign({}, state, { error: null });

        default:
            return state;
    }
}

export default wrapperReducer;